import { render, staticRenderFns } from "./panel.vue?vue&type=template&id=09211965&scoped=true"
import script from "./panel.vue?vue&type=script&lang=js"
export * from "./panel.vue?vue&type=script&lang=js"
import style0 from "./panel.vue?vue&type=style&index=0&id=09211965&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09211965",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TfGridTable: require('/usr/src/app/components/tf/grid-table.vue').default,ThumbnailProduct: require('/usr/src/app/components/thumbnail/product.vue').default})
